"use client";

import { Box } from "@chakra-ui/react";
import { useMemo } from "react";
import { PageTypeGlobal } from "@/lib/types";
import { useThemeTokens } from "@/lib/theme/tokens";
import { Button, NavLink, Text } from "@/components/ui";
import {
  buildClassesPageQuery,
  EMPTY_CLASSES_PAGE_URL_STATE,
} from "@/views/classes/hooks/classesPageUrl";

export interface TeacherClassesSectionProps {
  teacherId: number;
  teacherName: string;
}

export const TeacherClassesSection = ({
  teacherId,
  teacherName,
}: TeacherClassesSectionProps) => {
  const theme = useThemeTokens();

  const classesHref = useMemo(
    () =>
      `${PageTypeGlobal.Classes}${buildClassesPageQuery({
        ...EMPTY_CLASSES_PAGE_URL_STATE,
        teacher: String(teacherId),
      })}`,
    [teacherId],
  );

  return (
    <Box py={{ base: 5, md: 6 }} borderBottomWidth="1px" borderColor={theme.borderGlass.subtle}>
      <Text
        fontSize="xs"
        fontWeight="600"
        letterSpacing="0.14em"
        textTransform="uppercase"
        color={theme.text.tertiary}
        mb={1}
      >
        Classes
      </Text>
      <Text variant="secondary" fontSize="sm" mb={4} lineHeight="1.5">
        Browse the full schedule for classes taught by {teacherName}.
      </Text>

      <Button
        as={NavLink}
        href={classesHref}
        variant="primary"
        size="sm"
        fontSize="sm"
        px={4}
        borderRadius="8px !important"
      >
        View classes with this instructor
      </Button>
    </Box>
  );
};
